export enum LocationVerificationPillVisual {
    VERIFYING = 'verifying',
    SUCCESS = 'success',
    FAILED = 'failed'
}

export enum GeoLogRumTypes {
    PROGRESS = 'progress',
    PASSED = 'passed',
    REJECTED = 'rejected',
    FAILED = 'failed',
    INVALIDATED = 'invalidated',
    INIT = 'init',
    CALLBACK_SET = 'callbackSet',
    CONFIG_SET = 'configSet'
}
